import styled from 'styled-components';

import { NavLink as LinkR } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: -1;
  @media screen and (max-width: 768px) {
    z-index:999;
  }
  width: 100%;
  height: 100%;
  background: linear-gradient(160deg, #12313f 0%, #1f2d3d 100%);

  display: grid;
  align-items: center;
  left: 0;
  transition: opacity 0.3s ease-in-out, top 0.3s ease-in-out, visibility 0.3s;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};

  /* when closed, drop out of hit-testing so it can't swallow front-page taps */
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
`;


export const NavLogo = styled(LinkR)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: #01bf71;
  }
`;

export const CloseIcon = styled(FaTimes)`
  color: #fff;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  border: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`;

export const SidebarWrapper = styled.div`
  color: #fff;
`;

export const SidebarMenu = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
  padding: 80px 0 24px;
  margin: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  @media screen and (max-width: 480px) {
    gap: 16px;
  }
`;


export const MySidebarLink = styled(LinkR)`
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 1 rem;
  text-decoration: none;
  list-style: none;
 
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: #01bf71;
  
  }
`;


export const SideBtnWrap = styled.div`
  display: flex;
  justify-content: left;
`;

export const SidebarRoute = styled(LinkR)`
  border-radius: 50px;
  background: #01bf71;
  white-space: nowrap;
  padding: 16px 64px;
  color: #010606;
  font-size: 15px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;
